export default __webpack_public_path__ + "static/media/voucher.260832b6.svg";